// VX-4302: pure derivation between the pixel-data SharedWorker name and its generation number. Lives
// in modules/viewer/workers with no React/Recoil dependencies so it is importable from SharedWorker
// scope, where the worker parses its own generation out of `self.name` for self-retirement.

export const PIXEL_WORKER_BASE_NAME = {
  deduped: 'Pixel Data Shared Worker [deduped]',
  legacy: 'Pixel Data Shared Worker [legacy]',
} as const;

const GENERATION_SUFFIX_RE = / gen-(\d+)$/;

// Generation 0 keeps the existing bare name so a flag-on-at-rest client and a flag-off client share
// one worker; the `gen-N` suffix appears only from generation 1 (reachable only with the flag on).
export function pixelWorkerName(useDeduped: boolean, generation: number): string {
  const base = useDeduped ? PIXEL_WORKER_BASE_NAME.deduped : PIXEL_WORKER_BASE_NAME.legacy;
  return generation >= 1 ? `${base} gen-${generation}` : base;
}

// Inverse of pixelWorkerName: an unrecognized or bare name reads as generation 0 rather than
// throwing, so a bare-name gen-0 worker never mis-parses itself.
export function parseGenerationFromName(name: string): number {
  const match = GENERATION_SUFFIX_RE.exec(name);
  return match ? Number(match[1]) : 0;
}
